import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarService } from '@core/services/sidebar.service';
import { ISidebar } from '@models/ISidebar';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { SessionService } from '@core/services/session.service';

@Component({
  selector: 'app-nav-sidebar',
  imports: [CommonModule, TranslateModule, RouterModule],
  templateUrl: './nav-sidebar.component.html',
  styleUrl: './nav-sidebar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavSidebarComponent implements OnInit, OnDestroy {
  private sub?: Subscription;
  isOpenSubMenu?: Partial<ISidebar> | undefined;

  rawSidebarItems: ISidebar[] = [];

  constructor(
    public sidebarService: SidebarService,
    private cdr: ChangeDetectorRef,
    private sessionService: SessionService
  ) { }

  async ngOnInit(): Promise<void> {

    // this.sub = this.router.events
    //   .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
    //   .subscribe((e) => {
    //     const url = e.urlAfterRedirects.split('?')[0].split('#')[0];
    //     if (url === '/') this.closeSubMenu();
    //   });

    await this.loadSidebarItems();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  handlerClick(label: ISidebar) {
    if (!label.subLabel?.length) {
      //this.router.navigate([label.url]);
      return;
    }
    this.isOpenSubMenu = label;

  }


  private async loadSidebarItems(): Promise<void> {
    const modulos = await this.sessionService.getOrLoadUserModules();
    if (modulos.length === 0) {
      this.rawSidebarItems = [];
      return;
    }

    this.rawSidebarItems = this.sidebarService.transformarSidebar(modulos);
    this.cdr.markForCheck();
  }

  formatearNombres(label: string) {
    return label;
  }

  closeSubMenu() {
    this.isOpenSubMenu = {
      id: undefined,
      label: this.isOpenSubMenu?.label || '',
      url: this.isOpenSubMenu?.url || '',
      subLabel: this.isOpenSubMenu?.subLabel || [],
      traduccion: this.isOpenSubMenu?.traduccion || ''
    };


    setTimeout(() => {
      this.isOpenSubMenu = undefined;
    }, 200);
  }
}